
import { motion } from "framer-motion";
import "./FeaturedListings.css";
import img1 from "../Images/DowntownLoft.jpg";
import img2 from "../Images/SuburbanHome.jpg";
import img3 from "../Images/ChicStudioApartment.jpg";
import { useNavigate } from "react-router-dom";
import { getGalleries, getProperties } from "../../Services/Operations/ProductAPI";
import React, { useEffect, useState ,useRef} from "react";
import "./FeaturedSales.css";
import { FaBed, FaBath } from "react-icons/fa";
import { MdSquareFoot } from "react-icons/md";
import Bedroom from "../Images/Bedroom.jpg";
import { useSelector } from "react-redux";

const listings = [
  { img: img1, name: "Modern Downtown Loft", place: "New York, NY", price: "₹3,200/mo", beds: 2, bath: 2, size: "1450 sqft" },
  { img: img2, name: "Sunny Suburban Home", place: "Austin, TX", price: "₹4,500/mo", beds: 4, bath: 3, size: "2100 sqft" },
  { img: img3, name: "Chic Studio Apartment", place: "San Francisco, CA", price: "₹2,100/mo", beds: 1, bath: 1, size: "750 sqft" },
  { img: img1, name: "Modern Downtown Loft", place: "New York, NY", price: "₹3,200/mo", beds: 2, bath: 2, size: "1450 sqft" },
];

const FeaturedListings = () => {
  const scrollRef = useRef(null);

  const scroll = (dir) => {
    if (!scrollRef.current) return;
    const el = scrollRef.current;
    const offset = dir === "left" ? -el.clientWidth / 2 : el.clientWidth / 2;
    el.scrollBy({ left: offset, behavior: "smooth" });
  };

  const[properties,setProperties]=useState([])
    const navigate = useNavigate();
    const { isAuthenticated,token} = useSelector((state) => state.auth);
  
    const handleGetProperties=async()=>{
     try {
      const res=await getProperties()
      console.log('getProperties',res);
      if(res.status===200){
        setProperties(res.data.data)
      }
      
     } catch (error) {
      console.log(error);
      
     }
    }
  
      const handleGetGalleries=async()=>{
     try {
      const res=await getGalleries()
      console.log('getGalleries',res);
      
     } catch (error) {
      console.log(error);
      
     }
    }
  
    useEffect(() => {
      handleGetProperties()
    }, [])

  return (
    <section className="listings container">
      <div className="list-header">
        <h2 className="section-title">Featured Listings</h2>
      </div>

      <div className="slider-container">
        <button className="arrow left" onClick={() => scroll("left")} aria-label="prev">&#10094;</button>

        <div className="cards-wrapper">
        {properties.map((item) => (
          <div className="featured-card" key={item.id} >
            <img src={Bedroom} alt="property" className="featured-image" />

            <div className="featured-card-body">
              <h3 className="featured-price">{item?.property_name}</h3>
              
              <p className="featured-title">₹{item?.rent_amount}</p>
              <p className="featured-title">Security Deposit :₹({item?.security_deposit})</p>
              <p className="featured-location">{item?.location}</p>
              <p className="featured-location">{item?.facilities}</p>
              <p className="featured-date">{item?.created_at}</p>

              <div className="featured-icons">
                <span>
                  <MdSquareFoot />{item?.plot_size} m²
                </span>


                <span>
                  <FaBed /> 3+1
                </span>

                <span>
                  <FaBath /> 10
                </span>

                
              </div>
            </div>
          </div>
        ))}
      </div>
        <button className="arrow right" onClick={() => scroll("right")} aria-label="next">&#10095;</button>
      </div>
    </section>
  );
};

export default FeaturedListings;
